import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Sidebar from "@/components/Sidebar";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import KnowledgeBase from "@/pages/KnowledgeBase";
import LessonReader from "@/pages/LessonReader";
import ContentVault from "@/pages/ContentVault";
import AiChat from "@/pages/AiChat";
import Stats from "@/pages/Stats";
import { Menu } from "lucide-react";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppLayout({ children }) {
  const location = useLocation();
  const { user } = useAuth();
  const isLogin = location.pathname === "/login";
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (isLogin) return children;

  return (
    <div className="flex bg-[#0A0A0C] min-h-screen">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobile top bar */}
      <div className="fixed top-0 left-0 right-0 h-12 bg-[#0A0A0C] border-b border-white/10 flex items-center px-4 z-20 md:hidden">
        <button
          onClick={() => setSidebarOpen(true)}
          data-testid="mobile-menu-btn"
          className="text-[#94A3B8] hover:text-white p-1.5 rounded-lg hover:bg-white/5"
        >
          <Menu className="w-5 h-5" />
        </button>
        <span className="ml-3 text-sm font-semibold text-white" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>BehaviorBase</span>
      </div>

      {/* Main content */}
      <main className="flex-1 min-w-0 md:ml-64 pt-12 md:pt-0">
        {children}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/knowledge" element={<ProtectedRoute><KnowledgeBase /></ProtectedRoute>} />
            <Route path="/lesson/:id" element={<ProtectedRoute><LessonReader /></ProtectedRoute>} />
            <Route path="/vault" element={<ProtectedRoute><ContentVault /></ProtectedRoute>} />
            <Route path="/chat" element={<ProtectedRoute><AiChat /></ProtectedRoute>} />
            <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppLayout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
